export default {"src":"/_next/static/media/warrantyUnnumbered.557e6b48.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};